module.exports = __webpack_public_path__ + "img/cursor.45de18a3.svg";